export default __webpack_public_path__ + "static/media/c_icon2.973fda48.png";